import MerchantGiftCardRedeem from '@/components/public/merchantGiftCard/redeem';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const MerchantGiftCardRedeemPage = (): JSX.Element => {
    const { merchantId } = useParams<{ merchantId: string }>();

    return (
        <Box
            sx={{
                minHeight: 'calc(100vh - 200px)',
                display: 'flex',
                justifyContent: 'center',
                py: { xs: 3, sm: 5 }
            }}
        >
            <MerchantGiftCardRedeem merchantId={merchantId} />
        </Box>
    );
};

export default MerchantGiftCardRedeemPage;
